import { createContext, useContext } from 'react'
import { UpdateCabinetData } from './cabinet-info.types';

export interface ICabinetUpdateContext {
  updating: boolean;
  update: (cabinetId: string, data: UpdateCabinetData) => Promise<boolean>;
  updateActive: (cabinetId: string, active: boolean) => Promise<boolean>;
}

export const CabinetUpdateContext = createContext<ICabinetUpdateContext | null>(null);

export const useCabinetUpdate = () => {
  const context = useContext(CabinetUpdateContext);

  if (!context) {
    throw new Error('hook mast be used in CabinetUpdateContext');
  }

  return context;
}
